"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoFull = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var LogoFull = function LogoFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 166 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M128.698 26.145a3.011 3.011 0 01-.994 2.1 3.384 3.384 0 01-2.311.749 3.298 3.298 0 01-1.775-.476 3.152 3.152 0 01-1.183-1.355A4.887 4.887 0 01122 25.12v-.778a4.932 4.932 0 01.423-2.098 3.186 3.186 0 011.21-1.399 3.37 3.37 0 011.823-.491 3.254 3.254 0 012.242.754 3.136 3.136 0 011 2.136h-1.455a2.074 2.074 0 00-.53-1.31 1.751 1.751 0 00-1.246-.4 1.707 1.707 0 00-1.464.696c-.34.464-.515 1.148-.521 2.044v.746c0 .91.163 1.601.488 2.07a1.622 1.622 0 001.423.72c.465.034.927-.104 1.296-.388.329-.352.523-.809.548-1.29l1.461.012zM132.645 27.716h3.819v1.169h-5.281V20.47h1.462v7.246zM145.112 24.896a5.198 5.198 0 01-.437 2.172 3.262 3.262 0 01-1.222 1.432 3.59 3.59 0 01-3.654 0 3.31 3.31 0 01-1.237-1.423 5.024 5.024 0 01-.441-2.133v-.474a5.147 5.147 0 01.435-2.174 3.305 3.305 0 011.231-1.441 3.35 3.35 0 011.825-.5 3.396 3.396 0 011.823.494c.545.342.976.837 1.24 1.423.3.679.45 1.415.437 2.157v.467zm-1.461-.438c0-.931-.175-1.647-.53-2.144a1.852 1.852 0 00-1.489-.744 1.867 1.867 0 00-1.49.744c-.358.497-.538 1.183-.547 2.1v.485c0 .926.18 1.64.541 2.145a1.877 1.877 0 001.491.757 1.87 1.87 0 001.5-.739c.349-.494.524-1.213.524-2.163v-.44zM153.908 20.47v5.622a2.727 2.727 0 01-.861 2.121 3.253 3.253 0 01-2.284.781 3.28 3.28 0 01-2.293-.772 2.748 2.748 0 01-.837-2.133v-5.622h1.456v5.622c-.035.47.118.933.426 1.29a1.673 1.673 0 001.26.443c1.124 0 1.687-.591 1.687-1.775V20.47h1.446zM156.651 28.885V20.47h2.485a3.902 3.902 0 011.979.497c.574.33 1.039.821 1.338 1.412.325.648.488 1.366.473 2.091v.42a4.463 4.463 0 01-.476 2.104 3.37 3.37 0 01-1.358 1.408 4.072 4.072 0 01-2.021.491l-2.42-.008zm1.461-7.234v6.065h.953a2.201 2.201 0 001.775-.719c.411-.48.619-1.183.627-2.071v-.461c0-.915-.198-1.61-.591-2.092a2.108 2.108 0 00-1.728-.722h-1.036zM56.962 1.896h-2.959l-2.266 13.678H63.57l.4-2.367h-8.876l1.867-11.31zM77.42 2.243a1.595 1.595 0 00-1.183-.338 3.012 3.012 0 00-1.441.462 4.18 4.18 0 00-.867.887l-9.05 12.32h3.603L75.8 6.157l1.044 3.198h-3.047l-1.758 2.367h5.773l1.511 3.825 3.604.024-4.793-12.317a2.307 2.307 0 00-.713-1.011zM88.828 5.538a4.858 4.858 0 013.27-1.251h7.272l.4-2.39h-8.007a7.435 7.435 0 00-4.979 1.834A7.847 7.847 0 0084.16 8.58c-.335 2.009 0 3.686 1 5.006 1 1.32 2.447 1.988 4.337 1.988H97.5l.402-2.367H90.63c-1.245 0-2.18-.423-2.846-1.228-.666-.804-.888-1.878-.669-3.174a5.292 5.292 0 011.713-3.267zM111.112 1.896l-6.849 5.832a3.528 3.528 0 00-.417.382l1.024-6.214h-2.938l-2.266 13.678h2.958l1.003-6.056c.089.133.178.266.296.402l4.938 5.654h4.186l-6.227-6.698 8.494-6.98h-4.202z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.473 14.299l-5.068-12.403h3.202c.044.134 3.668 9.542 3.668 9.542.024.044.045.068.089.068h.024a.124.124 0 00.088-.044l7.136-9.566h3.116l-9.317 12.382c-.668.87-1.358 1.296-1.713 1.296s-.867-.402-1.225-1.275z",
    fill: "#1295DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.535 5.965a3.387 3.387 0 00-.2-1.88c-.643-1.452-2.072-2.168-4.27-2.189h-9.491l-2.27 13.678h9.498c2.31 0 4.023-.76 5.112-2.302.357-.488.59-1.056.678-1.654a3.033 3.033 0 00-.888-2.793 4.497 4.497 0 001.831-2.86zm-2.89-.024a1.837 1.837 0 01-1.183 1.34 4.344 4.344 0 01-1.758.358h-5.42l-.4 2.367h5.447a3.982 3.982 0 011.601.35c.592.295.867.715.778 1.274-.089.56-.488.962-1.183 1.252a4.816 4.816 0 01-1.69.313h-6.154l1.48-8.896h6.168c.56-.01 1.115.103 1.625.334.242.113.44.302.564.538.125.236.169.507.125.77z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.686 15.571c-2.133 0-3.645-.444-4.603-1.314a3.477 3.477 0 01-.888-1.36 5.367 5.367 0 01-.296-1.876 9.294 9.294 0 01.134-1.562s1.221-7.361 1.269-7.542h2.911l-1.231 7.497a5.522 5.522 0 00-.089 1.027c0 1.139.424 1.985 1.225 2.387.666.358 1.311.536 3.089.536 1.479 0 2.024-.222 2.846-.737.51-.312.932-.75 1.225-1.272a5.912 5.912 0 00.666-1.917s1.216-7.367 1.26-7.542h2.846l-1.233 7.498a8.724 8.724 0 01-.956 2.855 5.878 5.878 0 01-1.746 1.952c-1.245.888-2.92 1.326-5.05 1.326l-1.379.044zM150.183 15.574c.045-.27 2.246-13.5 2.27-13.678h12.739a257.65 257.65 0 00-.355 2.19h-9.695a.102.102 0 00-.073.022.102.102 0 00-.036.067l-1.515 9.053v.02c0 .024.023.045.023.069a.128.128 0 00.089.044h9.684c-.045.225-.335 2.012-.379 2.19l-12.752.023z",
    fill: "#1295DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.965 9.817c.044-.222.334-2.03.355-2.187h8.36c-.041.222-.331 2.03-.375 2.187h-8.34z",
    fill: "#1295DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.405.095A14.453 14.453 0 110 14.547 14.432 14.432 0 0114.405.095z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.405 27.16a12.612 12.612 0 1112.571-12.613 12.595 12.595 0 01-12.57 12.613z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.405 4.438a10.092 10.092 0 1010.06 10.08 10.06 10.06 0 00-10.06-10.08z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.905 15.287C12.722 5.16 8.811 2.071 4.382 0c0 0-.619 8.982 8.523 15.287z",
    fill: "#688D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.722 14.882C12.57 5.734 8.618 2.222 4.547.334c0 0-.165 8.696 8.175 14.548z",
    fill: "url(#prefix__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.571 15.908C8.024 10.06 4.381 9.914.905 10.651c0 0 3.5 5.544 11.666 5.257z",
    fill: "#3677AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.071 15.695c-4.19-5.376-7.905-5.541-10.888-4.923a13.678 13.678 0 0010.888 4.923z",
    fill: "url(#prefix__paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.405 20.615l-4.523.296s.976-4.343 2.728-5.455v-.071a23.504 23.504 0 00-.592-5.066l2.858 3.965a5.456 5.456 0 015.952 0c2.209.108 4.401.428 6.548.956 0 0-4.264-.237-6.805.955 0-.023-.666 3.628-6.166 4.42z",
    fill: "#E1AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.358 20.414l-4.216.296s.953-4.275 2.663-5.183l-.071-.095a22.947 22.947 0 00-.406-4.373l2.43 3.465s3.07-2.03 5.917-.048c1.747-.025 3.49.18 5.183.613a11.967 11.967 0 00-5.453.917c.024 0-.57 3.701-6.047 4.408z",
    fill: "url(#prefix__paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.024 19.278s1.665 5.621 3.165 6.187c-1.094.381-3.023 1.313-4.307 2.698-.071.121-.669-5.494 1.142-8.885z",
    fill: "#A70E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.953 19.636s1.586 5.302 2.858 5.781c-.93.296-2.764 1.184-3.846 2.388-.06.121-.441-4.826.988-8.169z",
    fill: "url(#prefix__paint3_linear)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear",
    x1: 6.18,
    y1: 0.444,
    x2: 11.793,
    y2: 15.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear",
    x1: 1.825,
    y1: 11.041,
    x2: 11.947,
    y2: 15.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#579CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear",
    x1: 17.636,
    y1: 10.752,
    x2: 19.252,
    y2: 19.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DCA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9D793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F5C35B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F1B42E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EEAC07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear",
    x1: 11.648,
    y1: 19.89,
    x2: 10.355,
    y2: 27.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7604A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D44635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CE2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC0E1E"
  }))));
};
exports.LogoFull = LogoFull;